// @ts-ignore
import * as Browser from '@waze/george/lib/browser'

export enum OS {
  other = 'other',
  ios = 'ios',
  android = 'android'
}

export function identifyOS(): OS {
  const deviceType = Browser.getDeviceType()
  if (deviceType === 'ios') {
    return OS.ios
  } else if (deviceType === 'android') {
    return OS.android
  }

  return OS.other
}

export function isMobile() {
  const os = identifyOS()
  return os === OS.ios || os === OS.android
}
